// extracted by mini-css-extract-plugin
export default {"CartPlaceholder":"CartPlaceholder_CartPlaceholder__2pPjN","CartPlaceholder__img":"CartPlaceholder_CartPlaceholder__img__2dMQ1"};